import { Component } from '@angular/core';

@Component({
  selector: 'fgb-register-success',
  templateUrl: './register-success.component.html',
  styleUrl: './register-success.component.scss'
})
export class RegisterSuccessComponent {

}
